import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import MdaePopup, {
  MdaePopupTitle,
  MdaePopupContent,
  MdaePopupFooter,
  MdaePopupFooterStartButtons,
  MdaePopupFooterEndButtons,
} from "../../../../common_components/common_widgets/popup";
import { actions } from "async-ops";
import MdaeTabPanel from "../../../../common_components/common_widgets/tab-panel";
import { Item } from "devextreme-react/tab-panel";
import {
  SET_CASE_DETAIL_DATA,
  TOGGLE_CASE_DETAIL_POPUP,
} from "../../case-detail/reducers/case-detail-reducer";
import CaseFields from "../../../../common_components/case-details/case-fields";
import ExtraFields from "../../../../common_components/case-details/extra-fields";
import { GET_CASE_CLAIM_DETAILS } from "../../../../common_components/case-details/services/get-case-claim-details";
import MdaeButton from "../../../../common_components/common_widgets/button";
import Guid from "devextreme/core/guid";
import { SET_CASE_FORM_DATA, SET_TARGET_TYPE_VALUE_LIST } from "../../case-detail/case-data/reducers/case-data-reducer";
import { toggleBillHistoryPopupVisible } from "../bill-history";
import { assignAtRiskAmntForLine } from "../remit-detail/remit-fields";

export const toggleClaimDetailPopupVisible = (
  dispatch,
  isVisible,
  claimParams?
) => {
  if (isVisible) {
    dispatch({
      type: SET_CASE_DETAIL_DATA,
      data: {
        caseDetailData: claimParams,
      },
    });
    dispatch(
      actions.asyncOperationStart(GET_CASE_CLAIM_DETAILS, {
        caseDetailId: claimParams?.caseDetailId,
        type: "view",
      })
    );
  }
  else{
    dispatch({
     type: SET_TARGET_TYPE_VALUE_LIST,
     data: { targetTypeSelectedList: [] },
   });
  }
  dispatch({
    type: TOGGLE_CASE_DETAIL_POPUP,
    data: {
      isClaimDetailPopupVisible: isVisible,
    },
  });
};

const ClaimDetail: React.FC<any> = () => {
  const dispatch = useDispatch();
    const caseData = useSelector(
      (state) => state["caseDataReducer"].caseData
  );
  const currentImportRoundData = useSelector(
    (state) => state["caseDataReducer"].currentImportRoundData
  );
  const targetTypeSelectedList = useSelector(
    (state) => state["caseDataReducer"].targetTypeSelectedList
  );
  const isVisibleFromImportCharges = useSelector(
  (state) => state["billHistoryReducer"].isVisibleFromImportCharges
);
  const getClaimDetailPopupTitle = () => {
    return (
      <MdaePopupTitle
        closePopupHandler={() => {
          toggleClaimDetailPopupVisible(dispatch, false);
        }}
      >
        Case Detail
      </MdaePopupTitle>
    );
  };

  const onClickApplyBtn = useCallback(() => {
    toggleClaimDetailPopupVisible(dispatch, false);
    // targetTypeSelectedList is a list of objects
    toggleBillHistoryPopupVisible(dispatch, false, null, false);
    
    if (caseData?.roundData) {
      const currentRound = caseData.roundData.find(
        (round) => round.eaRoundCaseId === currentImportRoundData.eaRoundCaseId
      );
      let roundCharges = currentRound ? currentRound.roundCharges || [] : [];
      //  1. Identify NEW objects to ADD
      
      let unSavedSelectedTypeList = assignAtRiskAmntForLine(targetTypeSelectedList, roundCharges, 'CLAIM');

      const newObjs = unSavedSelectedTypeList
        .filter(
          (obj) =>
            obj.isChecked === true &&
            !roundCharges.some(
              (item) =>
                item.roundTargetType === obj.targetType &&
                item.roundTargetValue === obj.codeValue
              // item.type === obj.type &&
              // item.caseDetailId === obj.caseDetailId
            )
        )
        .map((obj) => ({
          ...obj,
          roundTargetType: obj.targetType,
          roundTargetValue: obj.codeValue,
          eaRoundCaseLineLevelTrackingIdString: new Guid().toString(),
          billingCaseDetailId: obj.caseDetailId,
          claimRemitType: obj.type,
        }));

      //  2. Identify objects to REMOVE (unchecked)

      const toRemove = unSavedSelectedTypeList.filter(
        (obj) => obj.isChecked === false
      );

      //  3. Update roundData → remove unchecked, add new checked
      const updatedRoundData = caseData.roundData.map((round) => {
        if (round.eaRoundCaseId === currentImportRoundData.eaRoundCaseId) {
          const filteredCharges = round.roundCharges.filter(
            (charge) =>
              !toRemove.some(
                (r) =>
                  r.targetType === charge.roundTargetType &&
                  r.codeValue === charge.roundTargetValue
              )
          );
          return {
            ...round,
            roundCharges: [...filteredCharges, ...newObjs],
          };
        }
        return round;
      });
      dispatch({
        type: SET_CASE_FORM_DATA,
        data: {
          caseData: {
            ...caseData,
            roundData: updatedRoundData,
          },
        },
      });
    }
  }, [caseData, currentImportRoundData, dispatch, targetTypeSelectedList]);

  return (
    <MdaePopup
      deferRendering={false}
      height={630}
      width={1300}
      mdaeTitleRender={getClaimDetailPopupTitle}
      mdaeDataUpdaterConfig={[
        {
          actionType: TOGGLE_CASE_DETAIL_POPUP,
          reducerName: "caseDetailReducer",
          widgetOptionBindings: {
            visible: "isClaimDetailPopupVisible",
          },
        },
      ]}
      mdaeContentRender={() => {
        return (
          <div>
            <MdaePopupContent>
              <MdaeTabPanel>
                <Item title="Case Fields">
                  <CaseFields
                    isHideBillingHistoryLink={true}
                    isFromCasePreview={true}
                  ></CaseFields>
                </Item>
                <Item title="Extra Fields">
                  <ExtraFields></ExtraFields>
                </Item>
              </MdaeTabPanel>
            </MdaePopupContent>
          </div>
        );
      }}
      mdaeFooterRender={() => {
          return (
            isVisibleFromImportCharges && (
            <MdaePopupFooter>
              <MdaePopupFooterStartButtons>
                <MdaeButton
                  id={"pnlCancelCaseFieldSecondaryBtn"}
                  role={"secondary"}
                  onClick={() => {
                    toggleClaimDetailPopupVisible(dispatch, false);
                  }}
                >
                  Cancel
                </MdaeButton>
              </MdaePopupFooterStartButtons>
              <MdaePopupFooterEndButtons>
                <MdaeButton
                  id={"pnlApplyImportChargesBtn"}
                  role={"primary"}
                  onClick={onClickApplyBtn}
                >
                  Apply
                </MdaeButton>
              </MdaePopupFooterEndButtons>
            </MdaePopupFooter>
            )
          );
        }}
    ></MdaePopup>
  );
};

export default ClaimDetail;
